module.exports = __webpack_public_path__ + "img/dark-grey.988fa5ed.png";